/*  
 *  Archivo destinado a manejar todas las funciones responsables de comunicación con 
 *  el servidor, referentes al usuario.
 */

import fetchData from "./utils/fetchData";

const url = process.env.REACT_APP_SERVER_URL + '/almacen';

export const EnviarIngresarAlmacen = async (datos, currentUser, dispatch) => {
    //la variable "datos" contiene: { id, codigoBarras, nombreProducto, descripcion, marcaState, categoriaState, habilitado }
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> IngresarAlmacen');
    //console.log(currentUser);

    let body = datos;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/ingresar`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (NuevaMarca): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

export const getLastRowsAlmacen = async (currentUser, dispatch, setPreciosEnAlmacen) => {
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> getLastRows');
    //console.log(currentUser);

    let body = null;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/getLastRows`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_PRODUCTOS', payload: result });
        //console.log(result.rows)
        setPreciosEnAlmacen(result.rows)
    } else {
        console.log('Advertencia: No se recuperaron datos de almacen');
    }

    dispatch({ type: 'END_LOADING' })
}

export const ObtenerInformacionProducto = async (comando, nombreProducto, currentUser, dispatch) => {
    //la variable "datos" contiene: { id, codigoBarras, nombreProducto, descripcion, marcaState, categoriaState, habilitado }
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> IngresarAlmacen');
    //console.log(currentUser);

    let body = {comando, nombreProducto};
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/infoProducto`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (infoProducto): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}

export const moverProducto = async (comando, row, currentUser, dispatch) => {
    //la variable "datos" contiene: { id, codigoBarras, nombreProducto, descripcion, marcaState, categoriaState, habilitado }
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> MoverProducto');
    //console.log(currentUser);

    let body = {comando, row};
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/moverProducto`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        //dispatch({ type: 'UPDATE_MARCAS', payload: result });
        //console.log('Respuesta backend (moverProducto): ', result);
        dispatch({ type: 'END_LOADING' })
        return result;
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}